import LineInterface from 'app/interfaces/LineInterface';
import {GAMER_1} from 'app/utils/Consts';

export const fullNickHandicap = (line: LineInterface, num: number): string => {
    const gamer = line[`gamer_${num || GAMER_1}`];
    return gamer.game_name
        ? `${gamer.game_name} ${gamer.nick}`
        : gamer.nick;
};
